import { render, staticRenderFns } from "./BusinessMenuColumn.vue?vue&type=template&id=9cfe4ab2&"
import script from "./BusinessMenuColumn.vue?vue&type=script&lang=js&"
export * from "./BusinessMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports